import iconColombia from 'assets/images/colombia.png';
import ColombiaSiteCasanara from 'assets/images/Colombia_Casanara.jpg';
import ColombiaSiteCravoSur from 'assets/images/Colombia_CravoSur.jpg';

import iconGabon from 'assets/images/gabon.png';
import GabonLibreville from 'assets/images/Gabon_Libreville.jpg';
import GabonMaritime from 'assets/images/Gabon_Maritime.jpg';

import iconGreenland from 'assets/images/greenland.png';
import GreenlandFjord from 'assets/images/Greenland_Fjord.jpg';
import GreenlandIce from 'assets/images/Greenland_Ice_sheet.jpg';

import iconMexico from 'assets/images/mexico.png';
import MexicoGuanajuato from 'assets/images/Mexico_Guanajuato.jpg';
import MexicoNayarit from 'assets/images/Mexico_Nayarit.jpg';

import iconZambia from 'assets/images/zambia.png';
import ZambiaCopperbelt from 'assets/images/Zambia_Copperbelt.jpg';
import ZambiaKafueFlats from 'assets/images/Zambia_KafueFlats.jpg';

import iconDenmark from 'assets/images/Denmark.png';

import iconNiger from 'assets/images/Niger.png';

import iconThailand from 'assets/images/Thailand.png';

import iconTajikistan from 'assets/images/Tajikistan.png';

export const defaultIcons = [
  {
    icon: iconTajikistan,
    title: 'Tajikistan',
    latLng: [71.0, 39.0],
    partners: [
      'Asian Development Bank (ADB) - Fragile and Conflict-Affected Situations (FCAS)',
    ],
    sites: [],
  },
  {
    icon: iconThailand,
    title: 'Thailand',
    latLng: [100.5, 15.0],
    partners: [
      'Hydro – Informatics Institute (HII)',
    ],
    sites: [],
  },
  {
    icon: iconNiger,
    title: 'Niger',
    latLng: [ 3.8, 14.5],
    partners: [
      'AGRHYMET Regional Center',
      'Permanent Interstate Committee for drought control in the Sahel (CILSS)',
    ],
    sites: [],
  },
  {
    icon: iconDenmark,
    title: 'Denmark',
    latLng: [ 9.6, 56.2],
    partners: [
      'Statistics Denmark',
      'The Danish Agency for Data Supply and Infrastructure',
    ],
    sites: [],
  },
  {
    icon: iconColombia,
    title: 'Colombia',
    latLng: [-73.6, 7.82],
    partners: [
      'Institute of Hydrology, Meteorology and Environmental Studies (IDEAM)',
      'National Administrative Department of Statistics (DANE)',
    ],
    sites: [
      {
        type: 'Feature',
        properties: {
          nameHTML: '<b>Test site 1: Cravo Sur</b>',
          RR: false,
          image: ColombiaSiteCravoSur,
        },
        geometry: {
          type: 'Point',
          coordinates: [-71.21749794876325, 6.736502051236749],
        },
      },
      {
        type: 'Feature',
        properties: {
          nameHTML: '<b>Test site 2: Casanara</b> <i>(Used in Round Robin)</i>',
          RR: true,
          image: ColombiaSiteCasanara,
        },
        geometry: {
          type: 'Point',
          coordinates: [-72.70271361285336, 4.924352121466431],
        },
      },
    ],
  },
  {
    icon: iconGabon,
    title: 'Gabon',
    latLng: [11, 0],
    partners: [
      'Ministère de l’Eau et l’Énergie, Direction Générale de l’Eau et des Ressources Hydrauliques (DGRH)',
      'Ministère de l’Économie, Direction Générale de la Statistique (DGS)',
      'Ministère des Eaux et Forêts, Direction Générale de l’Environnement et de la Protection de la Nature (DGPEN)',
      'Agence Gabonaise d’Etudes et d’Observations Spatiales (AGEOS)',
    ],
    sites: [
      {
        type: 'Feature',
        properties: {
          nameHTML:
            '<b>Test site 1: Ogooué-Maritime</b> <i>(Used in Round Robin)</i>',
          RR: true,
          image: GabonMaritime,
        },
        geometry: {
          type: 'Point',
          coordinates: [9.490175779301747, -1.407525951066728],
        },
      },
      {
        type: 'Feature',
        properties: {
          nameHTML: '<b>Test site 2: Libreville</b>',
          RR: false,
          image: GabonLibreville,
        },
        geometry: {
          type: 'Point',
          coordinates: [9.935575603615508, 0.435322328560749],
        },
      },
    ],
  },
  {
    icon: iconGreenland,
    title: 'Greenland',
    latLng: [-49, 65.6],
    partners: [
      'The Government of Greenland’s Ministry of Finance',
      'ASIAQ Greenland Survey',
    ],
    sites: [
      {
        type: 'Feature',
        properties: {
          nameHTML:
            '<b>Test site 2: Ice sheet</b> <i>(Used in Round Robin)</i>',
          RR: true,
          image: GreenlandIce,
        },
        geometry: {
          type: 'Point',
          coordinates: [-49.82341520588182, 65.30857813307456],
        },
      },
      {
        type: 'Feature',
        properties: {
          nameHTML: '<b>Test site 1: Fjord</b>',
          RR: false,
          image: GreenlandFjord,
        },
        geometry: {
          type: 'Point',
          coordinates: [-51.9940362649919, 66.20789540907694],
        },
      },
    ],
  },
  {
    icon: iconMexico,
    title: 'Mexico',
    latLng: [-102, 23],
    partners: [
      'National Commission for Water (CONAGUA)',
      'National Institute of Statistics and Geography (INEGI)',
      'Center for Research in Geospatial Information Science (CentroGEO)',
    ],
    sites: [
      {
        type: 'Feature',
        properties: {
          nameHTML:
            '<b>Test site 2: Guanajuato/Michoacán</b> <i>(Used in Round Robin)</i>',
          RR: true,
          image: MexicoGuanajuato,
        },
        geometry: {
          type: 'Point',
          coordinates: [-101.3514783505462, 20.29086640316029],
        },
      },
      {
        type: 'Feature',
        properties: {
          nameHTML: '<b>Test site 1: Nayarit</b>',
          RR: false,
          image: MexicoNayarit,
        },
        geometry: {
          type: 'Point',
          coordinates: [-105.4376409524792, 22.11017239101669],
        },
      },
    ],
  },
  {
    icon: iconZambia,
    title: 'Zambia',
    latLng: [28, -13],
    partners: [
      'Water Resources Management Authority (WARMA)',
      'Central Statistical Office (CSO)',
      'Zambia National Remote Sensing Centre',
      'University of Zambia',
      'Mulungushi University',
    ],
    sites: [
      {
        type: 'Feature',
        properties: {
          nameHTML:
            '<b>Test site 1: Kafue flats</b> <i>(Used in Round Robin)</i>',
          RR: true,
          image: ZambiaKafueFlats,
        },
        geometry: {
          type: 'Point',
          coordinates: [27.424647495503361, -15.876982702957861],
        },
      },
      {
        type: 'Feature',
        properties: {
          nameHTML: '<b>Test site 2: Copperbelt</b>',
          RR: false,
          image: ZambiaCopperbelt,
        },
        geometry: {
          type: 'Point',
          coordinates: [27.503861654226291, -13.24719852280419],
        },
      },
    ],
  },
];
